export const ENTRYPOINT = '//extremapi.montournoi.net'
export const ENVIRONNEMENT = 'prod'
